import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './popup-filter.css';
export class Popup extends Component {
  static propTypes = {
    children: PropTypes.any,
    styles: PropTypes.object,
    isHasFaded: PropTypes.bool,
    className: PropTypes.any
  }

  render() {
    return (
      <div className='popup' >
        {this.props.isHasFaded && <div className='faded-popup' />}
        <div className={`popuptext ${this.props.className}`} id='s1-popup' style={this.props.styles}>
          {this.props.children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Popup/popup.js